import { useQuery } from "react-query";
import { loginPolicy } from "./auth-policy-service";

export const useLoginPolicy = (clientId: string, options?: any) => {
  return useQuery("policy/auth/login", () => loginPolicy(clientId), {
    enabled: !!clientId,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    ...options,
  });
};
